

export function ReportHeader() {
  return null
  // return (
  //   <Box>
  //     <Text fontSize="2xl" fontWeight="bold" color="var(--text-primary)">
  //       {title}
  //     </Text>
  //     <Text fontSize="sm" color="var(--text-muted)">
  //       {subtitle}
  //     </Text>
  //   </Box>
  // );
}
